export default function ImportantNotice() {
  return (
    <aside className="notice" aria-labelledby="notice-title">
      <h2 className="notice__title" id="notice-title">
        <svg className="notice__icon" viewBox="0 0 20 20" aria-hidden="true">
          <circle cx="10" cy="10" r="8.25" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <path d="M10 9v5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="10" cy="6.25" r="1" fill="currentColor" />
        </svg>
        Please note
      </h2>
      <ul className="notice__list">
        <li>Registering interest is not an application for a new connection or to change your electricity supplier.</li>
        <li>Switching will open only after HERC approves the consumer switching protocol. We will inform you when it does.</li>
        <li>Registration is free. Eleven Power will never ask you for any payment, deposit or document at this stage.</li>
      </ul>
    </aside>
  );
}
